export const getViewportId = (id: string): string => `wf-viewport-${id}`;
